import { createBrowserRouter } from 'react-router-dom';
import { AppShell } from '@/components/layout/AppShell';
import { trackPageView } from '@/lib/analytics';

// Lazy load pages
import { lazy } from 'react';

const Home = lazy(() => import('@/pages/Home'));
const About = lazy(() => import('@/pages/About'));
const MinisterBiography = lazy(() => import('@/pages/MinisterBiography'));
const Departments = lazy(() => import('@/pages/Departments'));
const DepartmentDetail = lazy(() => import('@/pages/DepartmentDetail'));
const Subsites = lazy(() => import('@/pages/Subsites'));
const Archive = lazy(() => import('@/pages/Archive'));
const Map = lazy(() => import('@/pages/Map'));
const Stats = lazy(() => import('@/pages/Stats'));
const Complaints = lazy(() => import('@/pages/Complaints'));
const Inquiries = lazy(() => import('@/pages/Inquiries'));
const Tenders = lazy(() => import('@/pages/Tenders'));
const TenderDetail = lazy(() => import('@/pages/TenderDetail'));
const Delegations = lazy(() => import('@/pages/Delegations'));
const Talents = lazy(() => import('@/pages/Talents'));
const TalentDetail = lazy(() => import('@/pages/TalentDetail'));
const SpecialNeeds = lazy(() => import('@/pages/SpecialNeeds'));
const WomenAffairs = lazy(() => import('@/pages/WomenAffairs'));
const AntiDoping = lazy(() => import('@/pages/AntiDoping'));
const Volunteering = lazy(() => import('@/pages/Volunteering'));
const QualityISO = lazy(() => import('@/pages/QualityISO'));
const Events = lazy(() => import('@/pages/Events'));
const EventDetail = lazy(() => import('@/pages/EventDetail'));
const Partners = lazy(() => import('@/pages/Partners'));
const PartnerDetail = lazy(() => import('@/pages/PartnerDetail'));
const GulfCup = lazy(() => import('@/pages/GulfCup'));
const SecurityClearance = lazy(() => import('@/pages/SecurityClearance'));
const WorldBank = lazy(() => import('@/pages/WorldBank'));
const OOR = lazy(() => import('@/pages/OOR'));
const EForms = lazy(() => import('@/pages/EForms'));
const Tests = lazy(() => import('@/pages/Tests'));
const TestRunner = lazy(() => import('@/pages/TestRunner'));
const AdminDashboard = lazy(() => import('@/pages/AdminDashboard'));
const NewsDetail = lazy(() => import('@/pages/NewsDetail'));
const ProgramDetail = lazy(() => import('@/pages/ProgramDetail'));
const PrivacyPolicy = lazy(() => import('@/pages/PrivacyPolicy'));
const TermsConditions = lazy(() => import('@/pages/TermsConditions'));
const Search = lazy(() => import('@/pages/Search'));
const NotFound = lazy(() => import('@/pages/NotFound'));

export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    children: [
      { index: true, element: <Home /> },
      { path: 'about', element: <About /> },
      { path: 'minister-biography', element: <MinisterBiography /> },
      { path: 'departments', element: <Departments /> },
      { path: 'departments/:id', element: <DepartmentDetail /> },
      { path: 'subsites', element: <Subsites /> },
      { path: 'archive', element: <Archive /> },
      { path: 'map', element: <Map /> },
      { path: 'stats', element: <Stats /> },
      { path: 'complaints', element: <Complaints /> },
      { path: 'inquiries', element: <Inquiries /> },
      { path: 'tenders', element: <Tenders /> },
      { path: 'tenders/:id', element: <TenderDetail /> },
      { path: 'delegations', element: <Delegations /> },
      { path: 'talents', element: <Talents /> },
      { path: 'talents/:id', element: <TalentDetail /> },
      { path: 'special-needs', element: <SpecialNeeds /> },
      { path: 'women-affairs', element: <WomenAffairs /> },
      { path: 'anti-doping', element: <AntiDoping /> },
      { path: 'volunteering', element: <Volunteering /> },
      { path: 'quality-iso', element: <QualityISO /> },
      { path: 'events', element: <Events /> },
      { path: 'partners', element: <Partners /> },
      { path: 'partners/:slug', element: <PartnerDetail /> },
      { path: 'events/:id', element: <EventDetail /> },
      { path: 'news/:id', element: <NewsDetail /> },
      { path: 'gulf-cup', element: <GulfCup /> },
      { path: 'security-clearance', element: <SecurityClearance /> },
      { path: 'world-bank', element: <WorldBank /> },
      { path: 'e-services/oor', element: <OOR /> },
      { path: 'e-forms', element: <EForms /> },
      { path: 'tests', element: <Tests /> },
      { path: 'tests/:id', element: <TestRunner /> },
      { path: 'admin', element: <AdminDashboard /> },
      { path: 'programs/:programType/:slug', element: <ProgramDetail /> },
      { path: 'privacy', element: <PrivacyPolicy /> },
      { path: 'terms', element: <TermsConditions /> },
      { path: 'search', element: <Search /> },
      { path: '*', element: <NotFound /> },
    ],
  },
]);

router.subscribe((state) => {
  if (state.navigation.state !== 'idle') {
    return;
  }

  const { pathname, search, hash } = state.location;
  trackPageView(`${pathname}${search}${hash}`);
});




